import React from "react";

import styles from "./SearchInput.module.scss";

/**
 * @param {String} value - value of search field
 * @param {Function} onChange  - event handler
 * @param {String} [size] - md/lg; default is lg
 * @param {String} [className] - additional className to add
 */
const SearchInput = props => {
    const size = props.size || "md";
    const placeholder = props.placeholder || "Search";
    return (
        <div
            className={`${styles["search"]} ${
                styles[`search-${size}`]
            } ${props.className || ""}`}
        >
            <input
                className={styles["search-input"]}
                type="text"
                autoComplete="none"
                placeholder={placeholder}
                onChange={props.onChange}
                value={props.value}
            />
            <i className="fas fa-search" />
        </div>
    );
};

export default SearchInput;
